<template>
  <!-- 作者首页 -->
  <div class="home">
    <Header></Header>
    <div class="banner">
     <a :href="Advertisement_img.url" target="_blank">
        <img :src="Advertisement_img.picture" alt="">
      </a>
    </div>
    <div class="main">
      <div class="main_home">
        <div class="userimg">
          <img class="border_img" v-if="details.business==1" src="@/assets/img/zhuanjia_daimg.png" alt="">
          <img class="border_img" v-if="details.business==2" src="@/assets/img/jigou_daimg.png" alt="">
          <img class="content_img" :src="details.headimgs" alt="">
        </div>
        <div class="main_home_content">
          <div class="main_home_content_name" style="font-size: 26px;color: #333333;margin-bottom:10px;font-weight: bold;">
            {{details.organization_name}}</div>
          <div class="main_home_content_title"
            style="color:#333;width:670px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
            {{details.organization_desc}}</div>
          <div class="main_home_content_bottom">
            <div class="classification">
              {{details.profession_name}}
            </div>
            <div class="fans">
              {{details.fans}} <span style="font-size:16px;color:#666666;margin-left:5px;">粉丝</span>
            </div>
          </div>
        </div>
        <div class="main_home_right">
          <div class="btn_guanzhu" v-if="isguanzhu==true" @click="guanzhu">关注</div>
          <div class="btn_guanzhu1" v-if="isguanzhu==false" @click="guanzhu">已关注</div>
        </div>
      </div>
      <div class="main_bottom">
        <!-- 列表 -->
        <div class="main_list">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="'全部 '+'('+total0+')'" name="first">
              <div class="list_box" v-for="(item,index) in Whole_Lisr" @click="Go_Details(item.info,item.id)"
                :key="index">
                <!-- 无图 -->
                <!-- <div class="list">
                  <div class="list_top">
                    <img src="../assets/img/yanbao_icon.png" alt="">
                    <div class='list_top_title'>{{item.info==1?item.patent_profile:item.info==2?item.report_profile:item.info==3?item.title:''}}</div>
                  </div>
                  <div class="list_center">
                    <div class="list_content_data">2021-09-24 15:40:53</div>
                  </div>
                  <div class="list_bottom">
                    <span>点赞：375</span>
                    <span>点赞：375</span>
                    <span>点赞：375</span>
                  </div>
                </div> -->
                <!-- 有图 -->
                <div class="list_img">
                  <div class="list_left">
                    <img v-if="item.info==1&&item.chart_img!=null" :src="item.chart_img==''?'http://research.qudong.com/img/kong_imgs1.8c407e55.png':item.chart_img" alt="">
                    <img v-if="item.info==2&&item.img!=null" :src="item.img" alt="">
                    <img v-if="item.info==3&&item.img!=''" :src="item.img" alt="">
                  </div>
                  <div class="list_right">
                    <div class="list_top">
                      <img v-if="item.info==1" src="../assets/img/zhuanli_icon.png" style="width:43px;height:20px;"
                        alt="">
                      <img v-if="item.info==2" src="../assets/img/yanbao_icon.png" style="width:43px;height:20px;"
                        alt="">
                      <img v-if="item.info==3" src="../assets/img/zixun_icon1.png" style="width:43px;height:20px;"
                        alt="">
                      <div class='list_top_title'>
                        {{item.info==1?item.patent_profile:item.info==2?item.report_profile:item.info==3?item.title:''}}
                      </div>
                    </div>
                    <div class="list_center">
                      <div class="list_content_data">
                        {{item.info==1?item.create_time:item.info==2?item.create_time:item.info==3?item.create_time:''}}
                      </div>
                    </div>
                    <div class="list_bottom">
                      <span style="margin-right:10px;">评论：{{item.info==3?item.num_comment:0}}</span>
                      <span style="margin-right:10px;">点赞：{{item.info==3?item.num_praise:0}}</span>
                      <span>收藏：{{item.info==3?item.num_collect:0}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination :page-size="10" :hide-on-single-page="true" @current-change="handleCurrentChange" :current-page="page0" background
                layout="prev, pager, next" :total="total0">
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane :label="'专利 '+'('+total1+')'" name="second">
              <div class="list_box" v-for="(item,index) in Patent_list" @click="Go_Details1(item.id)" :key="index">
                <!-- 有图 -->
                <div class="list_img">
                  <div class="list_left">
                    <img v-if="item.info==1&&item.chart_img!=null" :src="item.chart_img==''?'http://research.qudong.com/img/kong_imgs1.8c407e55.png':item.chart_img" alt="">
                  </div>
                  <div class="list_right">
                    <div class="list_top">
                      <img v-if="item.info==1" src="../assets/img/zhuanli_icon.png" style="width:43px;height:20px;"
                        alt="">
                      <div class='list_top_title'>{{item.patent_profile}}</div>
                    </div>
                    <div class="list_center">
                      <div class="list_content_data">{{item.create_time}}</div>
                    </div>
                    <div class="list_bottom">
                      <span style="margin-right:10px;">评论：0</span>
                      <span style="margin-right:10px;">点赞：0</span>
                      <span>收藏：0</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination :page-size="10" @current-change="handleCurrentChange1" :hide-on-single-page="true" :current-page="page1" background
                layout="prev, pager, next" :total="total1">
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane :label="'研报 '+'('+total2+')'" name="third">
              <div class="list_box" v-for="(item,index) in Report_list" @click="Go_Details2(item.id)" :key="index">
                <div class="list_img">
                  <div class="list_left">
                    <img v-if="item.info==2&&item.img!=null" :src="item.img" alt="">
                  </div>
                  <div class="list_right">
                    <div class="list_top">
                      <img v-if="item.info==2" src="../assets/img/yanbao_icon.png" style="width:43px;height:20px;"
                        alt="">
                      <div class='list_top_title'>{{item.report_profile}}</div>
                    </div>
                    <div class="list_center">
                      <div class="list_content_data">{{item.create_time}}</div>
                    </div>
                    <div class="list_bottom">
                      <span style="margin-right:10px;">评论：0</span>
                      <span style="margin-right:10px;">点赞：0</span>
                      <span>收藏：0</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination :page-size="10" :hide-on-single-page="true" @current-change="handleCurrentChange2" :current-page="page2" background
                layout="prev, pager, next" :total="total2">
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane :label="'资讯 '+'('+total3+')'" name="fourth">
              <div class="list_box" v-for="(item,index) in Real_list" @click="Go_Details3(item.id)" :key="index">
                <div class="list_img">
                  <div class="list_left">
                    <img v-if="item.img!=null&&item.img!=''" :src="item.img" alt="">
                  </div>
                  <div class="list_right">
                    <div class="list_top">
                      <img v-if="item.info==3" src="../assets/img/zixun_icon1.png" style="width:43px;height:20px;"
                        alt="">
                      <div class='list_top_title'>{{item.title}}</div>
                    </div>
                    <div class="list_center">
                      <div class="list_content_data">{{item.create_time}}</div>
                    </div>
                    <div class="list_bottom">
                      <span style="margin-right:10px;">评论：{{item.num_comment}}</span>
                      <span style="margin-right:10px;">点赞：{{item.num_praise}}</span>
                      <span>收藏：{{item.num_collect}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination :page-size="10" :hide-on-single-page="true" @current-change="handleCurrentChange3" :current-page="page3" background
                layout="prev, pager, next" :total="total3">
              </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 右侧 -->
        <div class="main_right Scientific_bx_right">
          <!-- 作者推荐 -->
          <div class="Author_recommendation">
            <div class="Author_recommendation_top">
              <div class="Author_recommendation_top_l">
                <div class="shugang"></div>
                <div class="titles">智库推荐</div>
              </div>
              <div class="more" @click="Go_ThinkTank">更多 ></div>
            </div>
            <div class="Author_recommendation_content">
              <div class="Author_recommendation_list" v-for="(item,index) in zzlist" @click="Go_AuthorsHome(item.qudong_uid,item.id)" :key="index">
                <img :src="item.headimgurl" alt="">
                <div class="Author_recommendation_list_title">{{item.nickname}}</div>
              </div>
            </div>
            <div class="Author_recommendation_bottom">
              <div class="Change_batch" @click="ChangeBatch()">
                <img src="../assets/img/huanyipi_icon.png" alt="">
                <span>换一批</span>
              </div>
            </div>
          </div>
          <!-- 热点推荐 -->
          <div class="Author_recommendation" style="height:auto;">
            <div class="Author_recommendation_top">
              <div class="Author_recommendation_top_l">
                <div class="shugang"></div>
                <div class="titles">最新发布</div>
              </div>
            </div>
            <div class="Hot_recommendation">
              <div class="Hot_list" v-for="(item,index) in New_Release" :key="index"
                @click="Go_InformationDetails(item.info,item.id)">
                <div class="Hot_list_title">
                  {{item.info==1?item.patent_profile:item.info==2?item.report_profile:item.info==3?item.title:''}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  metaInfo(){
     return{
        title: this.details.nickname==undefined?'个人主页':this.details.nickname+'的个人主页'+'_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
   inject: ["reload"],
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      token:localStorage.getItem("token"),
      activeName: "first",
      zzlist: [],
      details: "",
      Whole_Lisr: [], //全部
      total0: 0,
      page0: 1,
      Patent_list: [], //专利
      total1: 0,
      page1: 1,
      Report_list: [], //研报
      total2: 0,
      page2: 1,
      Real_list: [], //资讯
      total3: 0,
      page3: 1,
      isguanzhu:true,
      New_Release:[],
      Advertisement_img:'',
    };
  },
  mounted() {
    this.Details(this.$route.query.id);
    this.whole_list(this.$route.query.id); //全部列表
    this.ChangeBatch();
    this.patent_list(this.$route.query.id); //专利列表
    this.report_list(this.$route.query.id); //研报列表
    this.real_list(this.$route.query.id); //资讯列表
    this.New_release();
    this.advertisement_img();
  },
  methods: {
    // 广告图
    advertisement_img(){
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/img_zhiKu",
        params: {},
      }).then((res) => {
        // //console.log(res);
        this.Advertisement_img = res.data.data;
      });
    },
    Go_AuthorsHome(uid,id){
      var ids='';
      if(uid==null){
        ids=id;
      }else{
        ids=uid
      }
      this.$router.push({ name: "AuthorsHome",query: { id: ids }});
      this.reload();
    },
     // 最新发布跳转详情
    Go_InformationDetails(info,id) {
       if (info == 1) {
        this.$router.push({ name: "PatentDetails", query: { id: id } });
      } else if (info == 2) {
        this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
      } else {
        this.$router.push({ name: "InformationDetails", query: { id: id } });
      }
    },
    // 最新发布
    New_release(){
        Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal_list",
        params: {},
      }).then((res) => {
        // //console.log(res);
        this.New_Release = res.data.data;
      });
    },
      // 关注
    guanzhu() {
      if(this.token!=null){
        var ids='';
        if(this.details.qudong_uid==null){
          ids=this.details.id
        }else{
           ids=this.details.qudong_uid
        }
        Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/index/detail/relation",
        params: {
          id: ids,
        },
         headers: {
          token: this.token,
        },
      }).then((res) => {
        if(res.data.code==200){
          this.isguanzhu = false;
          this.$message.success("关注成功");
        }else if(res.data.code==201){
        this.isguanzhu = true;
        this.$message.warning("取消关注");
        }
      });
      }else{
        this.$message.warning("请您登录以后关注");
      }
    },
    // yiguanzhu(){
    //   Axios({
    //     method: "post",
    //     url: "https://researchadmin.qudong.com/index/detail/relation",
    //     params: {
    //       id: this.details.qudong_uid,
    //     },
    //     headers: {
    //       token: this.token,
    //     },
    //   }).then((res) => {
    //     //console.log(res);
    //     if (res.data.code == 201) {
    //       this.isguanzhu = true;
    //       this.$message.warning("取消关注");
    //     }
    //   });
    // },
    // 全部跳转详情
    Go_Details(info, id) {
      if (info == 1) {
        this.$router.push({ name: "PatentDetails", query: { id: id } });
      } else if (info == 2) {
        this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
      } else {
        this.$router.push({ name: "InformationDetails", query: { id: id } });
      }
    },
    // 专利跳转详情
    Go_Details1(id) {
      this.$router.push({ name: "PatentDetails", query: { id: id } });
    },
    // 研报跳转详情
    Go_Details2(id) {
      this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
    },
    // 资讯跳转详情
    Go_Details3(id) {
      this.$router.push({ name: "InformationDetails", query: { id: id } });
    },
    // 全部列表
    whole_list(id) {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal",
        params: {
          uid: id,
          type: 0,
          limit: 10,
          page: this.page0,
        },
      }).then((res) => {
        // //console.log(res.data.data);
        this.Whole_Lisr = res.data.data.data;
        this.total0 = res.data.data.total;
        // //console.log(this.Whole_Lisr);
      });
    },
    // 全部分页
    handleCurrentChange(newpage) {
      this.page0 = newpage;
      this.whole_list(this.$route.query.id);
    },
    // 专利列表
    patent_list(id) {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal",
        params: {
          uid: id,
          type: 1,
          limit: 10,
          page: this.page1,
        },
      }).then((res) => {
        // //console.log(res.data.data.data);
        this.Patent_list = res.data.data.data;
        this.total1 = res.data.data.total;
      });
    },
    // 专利分页
    handleCurrentChange1(newpage) {
      this.page1 = newpage;
      this.patent_list(this.$route.query.id);
    },

    // 研报列表
    report_list(id) {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal",
        params: {
          uid: id,
          type: 2,
          limit: 10,
          page: this.page2,
        },
      }).then((res) => {
        // //console.log(res.data.data.data);
        this.Report_list = res.data.data.data;
        this.total2 = res.data.data.total;
      });
    },
    // 研报分页
    handleCurrentChange2(newpage) {
      this.page2 = newpage;
      this.report_list(this.$route.query.id);
    },

    // 资讯列表
    real_list(id) {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal",
        params: {
          uid: id,
          type: 3,
          limit: 10,
          page: this.page3,
        },
      }).then((res) => {
        // //console.log(res.data.data.data);
        this.Real_list = res.data.data.data;
        this.total3 = res.data.data.total;
      });
    },
    // 资讯分页
    handleCurrentChange3(newpage) {
      this.page3 = newpage;
      this.real_list(this.$route.query.id);
    },
    Go_ThinkTank() {
      this.$router.push({ name: "ThinkTank" });
    },
    handleClick(tab, event) {
      // //console.log(tab, event);
    },
   
    ChangeBatch() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/cele_user_round",
        params: {},
      }).then((res) => {
        // //console.log(res.data.data);
        this.zzlist = res.data.data;
      });
    },
    // 详情展示
    Details(id) {
      var that=this;
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/user_personal",
        params: {
          uid: id,
        },
      }).then((res) => {
        //console.log(res.data.data);
        this.details = res.data.data;
        var ids='';
        if(this.details.qudong_uid==null){
          ids=this.details.id
        }else{
           ids=this.details.qudong_uid
        }
        if(that.token!=null){
          // //console.log(that.token)
          //  关注状态
              Axios({
                method: "post",
                url: "https://researchadmin.qudong.com/index/detail/relation_status",
                params: {
                  id: ids,
                },
                headers: {
                  token: this.token,
                },
              }).then((res) => {
                // //console.log(res.data.data);
                if (res.data.data == 0) {
                  this.isguanzhu = true;
                } else {
                  this.isguanzhu = false;
                }
              });
        }
      });
    },
  },
};
</script>

<style scoped>
.home {
  background: #f5f7f9;
}
.banner {
  width: 100%;
  height: 300px;
}
.banner img {
  width: 100%;
  object-fit: cover;
  height: 300px;
}
.main {
  width: 1200px;
  margin: 0 auto;
}
.main_home {
  width: 1116px;
  height: 170px;
  margin: 20px 0;
  background: #fff;
  padding: 24px 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main_home_left {
  position: relative;
}
.userimg {
  position: relative;
  width: 106px;
  height: 111px;
}
.main_home_content {
  margin-right: 100px;
}
.border_img {
  width: 106px;
  height: 111px;
  position: relative;
  z-index: 111;
}
.content_img {
  position: absolute;
  border-radius: 50%;
  width: 94px;
  top: 17px;
  left: 3px;
  height: 94px;
}
.classification {
  width: 112px;
  height: 28px;
  background-image: url("../assets/img/classification_img.png");
  font-size: 14px;
  font-weight: 400;
  color: #3463db;
  text-align: center;
  line-height: 28px;
  text-indent: 1.5rem;
}
.main_home_content_bottom {
  display: flex;
  margin-top: 20px;
}
.fans {
  margin-left: 29px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  display:flex;
  align-items: center;
}
.btn_guanzhu {
  width: 196px;
  height: 40px;
  background: #3463db;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
}
.btn_guanzhu1 {
  width: 196px;
  height: 40px;
  border:1px solid #E8E8E8;
  background: #fff;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  color: #999999;
  cursor: pointer;
}
.main_bottom {
  display: flex;
}
.main_list {
  width: 900px;
}
>>> .el-tabs {
  background: #fff;
  padding: 20px;
  margin-right: 20px;
}
.main_right {
  width: 320px;
  background: #fff;
}
.list_top_title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 540;
  color: #111111;
  margin-left: 10px;
}
.list_top {
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #111111;
}
.list_top_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.list_center {
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.list_bottom {
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.list {
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
}
>>> .el-tabs__header {
  margin: 0;
}
.list_img {
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
  display: flex;
  padding-top: 15px;
}
.list_left img {
  width: 128px;
  height: 82px;
  margin-right: 20px;
}

/* 右侧 */
.Scientific_bx_right {
  width: 320px;
  background: #f5f7f9;
}
.Scientific_bx_left_list {
  width: 820px;
  margin: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
}
.Scientific_bx_left_list_left {
  width: 300px;
  height: 180px;
  margin-right: 20px;
}
.Scientific_bx_left_list_left img {
  width: 300px;
  height: 180px;
  border-radius: 6px;
}
.Scientific_bx_left_list_right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.Scientific_bx_left_list_right .title {
  font-size: 23px;
}
.Scientific_bx_left_list_right_bottom {
  display: flex;
  justify-content: space-between;
}
.list_right_bottom_left {
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.list_right_bottom_left img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
}
.list_right_bottom_left span {
  margin-right: 15px;
}
.list_right_bottom_right {
  display: flex;
  align-items: center;
}

.list_right_bottom_right_imgtext {
  display: flex;
  margin-right: 20px;
}
.list_right_bottom_right_imgtext img {
  margin-right: 5px;
}
.Author_recommendation {
  width: 320px;
  height: 316px;
  background: #fff;
  margin-bottom: 20px;
}
.shugang {
  width: 4px;
  height: 28px;
  background: #3463db;
}
.titles {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #3463db;
  margin-left: 10px;
}
.Author_recommendation_top {
  width: 320px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}
.Author_recommendation_top_l {
  display: flex;
}
.more {
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #999999;
  margin-right: 15px;
  cursor: pointer;
}
.Author_recommendation_content {
  width: 260px;
  margin: 20px auto 0;
  /* padding:20px 30px 0; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}
.Author_recommendation_list {
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.Author_recommendation_list img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-bottom: 10px;

}
.Author_recommendation_bottom {
  width: 320px;
  height: 50px;
  line-height: 50px;
}
.Change_batch {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.Change_batch img {
  margin-right: 10px;
}
.Hot_list {
  display: flex;
  width: 290px;
  margin: 20px auto;
  /* padding:0px 15px; */
  justify-content: space-between;
  cursor: pointer;
}
.Hot_list_title {
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.Hot_recommendation {
  padding-bottom: 5px;
}
.Hot_list_data {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.Author_recommendation_list_title {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-align: center;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.list_box {
  cursor: pointer;
}
>>> .el-tabs__nav-wrap::after{
  height:1px !important;
}
>>> .el-tabs__item{
  color:#999;
  
}
>>> .is-active{
  color: #409EFF;
}
</style>